import api from './client'

export interface DashboardDomainRadarDatum {
  domain_name: string
  correct_count: number
  wrong_count: number
}

export interface StudentDashboardSummary {
  xp_total: number
  latest_rw_score: number | null
  latest_math_score: number | null
  day_streak: number
  streak_active_today: boolean
  recent_activity_dates: string[]
  domain_radar: DashboardDomainRadarDatum[]
}

export const dashboardApi = {
  student: () => api.get<StudentDashboardSummary>('/dashboard/student'),
}
